/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ToDoItemStatus } from './ToDoItemStatus';
import {
    ToDoItemStatusFromJSON,
    ToDoItemStatusFromJSONTyped,
    ToDoItemStatusToJSON,
} from './ToDoItemStatus';

/**
 * 
 * @export
 * @interface ToDoItemDetails
 */
export interface ToDoItemDetails {
    /**
     * 
     * @type {string}
     * @memberof ToDoItemDetails
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof ToDoItemDetails
     */
    dueReviewDate: Date;
    /**
     * 
     * @type {ToDoItemStatus}
     * @memberof ToDoItemDetails
     */
    status: ToDoItemStatus;
}

/**
 * Check if a given object implements the ToDoItemDetails interface.
 */
export function instanceOfToDoItemDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "dueReviewDate" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ToDoItemDetailsFromJSON(json: any): ToDoItemDetails {
    return ToDoItemDetailsFromJSONTyped(json, false);
}

export function ToDoItemDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToDoItemDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['Title'],
        'dueReviewDate': (new Date(json['DueReviewDate'])),
        'status': ToDoItemStatusFromJSON(json['Status']),
    };
}

export function ToDoItemDetailsToJSON(value?: ToDoItemDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Title': value.title,
        'DueReviewDate': (value.dueReviewDate.toISOString()),
        'Status': ToDoItemStatusToJSON(value.status),
    };
}

